import React from 'react'
import {Link} from 'react-router'
import {Card} from 'common/styleguide/Card'
import {IntroWidget} from 'common/IntroWidget'
import {ProgressBar} from 'common/ProgressBar'
import styles from './Goals.scss'
import {MiniListItem, MiniListItemDetail} from '../DashboardElements'
import {urls} from 'lib/urls'

const RoundProgress = ({progress}) => (
  <ProgressBar height='10px' progress={progress} primaryColor='#6982FF' styleInner={{borderRadius: '999px'}} styleOuter={{borderRadius: '999px', marginTop: '8px'}} />
)

export class Goals extends React.PureComponent {
  render () {
    const {goalParticipations} = this.props

    if (goalParticipations.size > 0) {
      return (
        <Card>
          {goalParticipations.valueSeq().slice(0, 3).map(gp => <MiniGoalCard gp={gp} key={gp.get('id')} />)}
          <Link data-card-link to='/goals'>View Goals</Link>
        </Card>
      )
    }

    return (
      <Card>
        <IntroWidget link={<Link to='/goals'>Add goals</Link>}>
          <p>Add a goal to stay motivated and challenge yourself and your friends.</p>
          <RoundProgress progress={0.8} />
        </IntroWidget>
      </Card>
    )
  }
}

// const text = Math.floor(progress * 100) + '% complete' + (trailer ? (' ∙ ' + trailer) : '')
export const MiniGoalCard = ({gp}) => (
  <MiniListItem to={urls.goals.show(gp.getIn(['goal', 'id']))} title={gp.getIn(['goal', 'name'])}>
    <MiniListItemDetail className={styles.goalDetail}>
      <span>{Math.floor(gp.getIn(['goal_params', 'percent']) * 100)}% complete</span>
      <span>{gp.getIn(['goal_params', 'trailer'])}</span>
    </MiniListItemDetail>
    <RoundProgress progress={gp.getIn(['goal_params', 'percent'])} />
  </MiniListItem>
)
